import { render, staticRenderFns } from "./building.vue?vue&type=template&id=2f2849ac&scoped=true&"
import script from "./building.vue?vue&type=script&lang=js&"
export * from "./building.vue?vue&type=script&lang=js&"
import style0 from "./building.vue?vue&type=style&index=0&id=2f2849ac&lang=scss&scoped=true&"
import style1 from "./building.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2849ac",
  null
  
)

export default component.exports